<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">Edit Membership Plan</h2>
      <p class="text-muted mb-0">Update your membership plan details</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-6 mb-4">
        <app-input-component
          [label]="'Plan Code *'"
          [type]="'text'"
          [(value)]="code"
          [placeholder]="'e.g., INDIVIDUAL_2025'"
        />
      </div>
      <div class="col-md-6 mb-4">
        <app-input-component
          [label]="'Plan Name *'"
          [type]="'text'"
          [(value)]="name"
          [placeholder]="'e.g., Individual Membership 2025'"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <label class="form-label">Coverage Type *</label>
        <app-selectorini
          [options]="[
            {value: 'individual', display: 'Individual'},
            {value: 'family', display: 'Family'}
          ]"
          [displayKey]="'display'"
          [(value)]="coverage"
        />
      </div>
      <div class="col-md-6 mb-4">
        <label class="form-label">Billing Cycle *</label>
        <app-selectorini
          [options]="[
            {value: 'annual', display: 'Annual'},
            {value: 'monthly', display: 'Monthly'}
          ]"
          [displayKey]="'display'"
          [(value)]="billing_cycle"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <app-input-component
          [label]="'Price (NOK) *'"
          [type]="'number'"
          [(value)]="price_cents"
          [placeholder]="'e.g., 100.00'"
        />
      </div>
      @if (coverage === 'family') {
        <div class="col-md-6 mb-4">
          <app-input-component
            [label]="'Max Children'"
            [type]="'number'"
            [(value)]="max_children"
            [placeholder]="'Leave empty for unlimited'"
          />
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    <div class="row w-100">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'neutral'"
          [label]="'Cancel'"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="'Update Plan'"
          [iconClass]="'fa fa-save'"
          [disabled]="!code || !name || !coverage"
          [loading]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
